// Mirrors @carvana/core-auth 2.11.0 defaultInterceptionUrls, which it does not export;
// interceptionUrls replaces that list rather than merging, so re-verify on upgrade.
const CORE_AUTH_DEFAULT_HOSTS = [
  'carvana.com',
  'carvana.io',
  'zagforward.com',
  'carvanatech.com'
] as const;

// core-auth drops entries containing '/', ':' or whitespace (logging interception-urls-invalid-entry) — bare hostnames only.
const getAuthInterceptionHosts = (): string[] => {
  const slateDomain = process.env.SLATE_DOMAIN;
  return slateDomain ? [...CORE_AUTH_DEFAULT_HOSTS, slateDomain] : [...CORE_AUTH_DEFAULT_HOSTS];
};

export { getAuthInterceptionHosts };
